export default __webpack_public_path__ + "static/dekoder-5543aa1a033217f1c38a3b1ff19370c4.png";